import { Link } from "react-router-dom";
import { IfEnabled } from "./IfEnabled";
import { NewsletterForm } from "./NewsletterForm";
import { useSiteSettings } from "../contexts/SiteSettingsContext";
import { Instagram, Mail, Phone } from "lucide-react";

export function Footer() {
    const { settings } = useSiteSettings();
    const wa = (settings?.whatsappNumber || "").trim();

    return (
        <footer className="bg-beige border-t border-inkDark/5 mt-24" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <div className="font-display text-3xl tracking-tight text-inkDark">Sukaanyas</div>
                    <p className="mt-4 text-inkMuted leading-relaxed max-w-md">
                        A premium boutique celebrating the timeless artistry of Indian women's wear &mdash;
                        sarees, lehengas and ethnic ensembles, hand-curated for the modern woman.
                    </p>
                    <IfEnabled flag="newsletter">
                        <div className="mt-6" data-testid="footer-newsletter">
                            <span className="label-eyebrow">Atelier letters</span>
                            <div className="mt-3">
                                <NewsletterForm source="footer" />
                            </div>
                        </div>
                    </IfEnabled>
                </div>

                <div className="lg:col-span-3">
                    <div className="label-eyebrow mb-4">Shop</div>
                    <ul className="space-y-2 text-inkDark">
                        <li><Link to="/category/sarees" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-sarees">Sarees</Link></li>
                        <li><Link to="/category/lehengas" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-lehengas">Lehengas</Link></li>
                        <li><Link to="/category/kurtis-kurta-sets" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-kurtis">Kurtis &amp; Kurta Sets</Link></li>
                        <li><Link to="/category/anarkali" className="hover:text-skyblueDeep transition-colors">Anarkali</Link></li>
                        <li><Link to="/category/accessories" className="hover:text-skyblueDeep transition-colors">Accessories</Link></li>
                    </ul>
                </div>

                <IfEnabled flag="footer_policies">
                    <div className="lg:col-span-2">
                        <div className="label-eyebrow mb-4">Policies</div>
                        <ul className="space-y-2 text-inkDark" data-testid="footer-policies">
                            <li><Link to="/policy/shipping" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-shipping">Shipping &amp; Delivery</Link></li>
                            <li><Link to="/policy/returns" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-returns">Returns &amp; Exchanges</Link></li>
                            <li><Link to="/policy/privacy" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-privacy">Privacy</Link></li>
                            <li><Link to="/policy/terms" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-terms">Terms</Link></li>
                            <li><Link to="/policy/loyalty" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-loyalty">Loyalty Programme</Link></li>
                            <li><Link to="/policy/cod" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-cod">Cash on Delivery</Link></li>
                            <li><Link to="/policy/promotions" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-promotions">Contests &amp; Promotions</Link></li>
                            <IfEnabled flag="contact_form">
                                <li><Link to="/contact" className="hover:text-skyblueDeep transition-colors" data-testid="footer-link-contact">Contact</Link></li>
                            </IfEnabled>
                        </ul>
                    </div>
                </IfEnabled>

                <div className="lg:col-span-3" data-testid="footer-contact">
                    <div className="label-eyebrow mb-4">Atelier</div>
                    <ul className="space-y-3 text-inkDark">
                        <li className="flex items-center gap-3"><Phone size={16} className="text-skyblueDeep" /> {wa || "+91 00000 00000"}</li>
                        <li className="flex items-center gap-3"><Mail size={16} className="text-skyblueDeep" /> hello@sukaanyas.com</li>
                        <li className="flex items-center gap-3"><Instagram size={16} className="text-skyblueDeep" /> @sukaanyas</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-inkDark/5">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-inkMuted">
                    <span>&copy; {new Date().getFullYear()} Sukaanyas. Crafted with care.</span>
                    <span className="label-eyebrow text-[10px]">Mumbai &middot; India</span>
                </div>
            </div>
        </footer>
    );
}
